import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'

export const activateMicrosoftSecureScore = (data: object) => {
  return axios.post(endpoints.activateMicrosoftSecureScore, data)
}

export const useActivateMicrosoftSecureScore = () => {
  const queryClient = useQueryClient()
  return useMutation(activateMicrosoftSecureScore, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.policies, ApiKey.list])
    },
  })
}
